import { StudioMasterComboBoxModel } from '../studio-master-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 撮影場所リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetStudioMasterListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetStudioMasterListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: StudioMasterComboBoxModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {StudioMasterComboBoxModel} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetStudioMasterListService
   */
  execute(model: StudioMasterComboBoxModel, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getStudioMaster', null);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetStudioMasterListService
   */
  success(data: any) {
    this.model.updateStudioMasterList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
